//import 'babel-polyfill'; 
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import '@okta/okta-auth-js/polyfill';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'
import App from './App';
import store from './store';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router} from 'react-router-dom';

import './index.css';
import "bootstrap/dist/css/bootstrap.min.css"

// After a new deploy, a browser tab still holding the previous build's bundle can
// request a chunk file that no longer exists (renamed/removed by the new build).
// Reload once to pick up the current index.html and matching chunk map.
const CHUNK_RELOAD_KEY = 'chunkLoadRetry';
const isChunkLoadError = (error) =>
  !!error && (error.name === 'ChunkLoadError' || /Loading chunk [\w.-]+ failed/i.test(error.message || ''));

const handleChunkLoadError = (error) => {
  if (!isChunkLoadError(error)) return;
  if (window.sessionStorage.getItem(CHUNK_RELOAD_KEY)) return;
  window.sessionStorage.setItem(CHUNK_RELOAD_KEY, '1');
  window.location.reload();
};

window.addEventListener('error', (event) => handleChunkLoadError(event.error));
window.addEventListener('unhandledrejection', (event) => handleChunkLoadError(event.reason));
window.addEventListener('load', () => {
  setTimeout(() => window.sessionStorage.removeItem(CHUNK_RELOAD_KEY), 10000);
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <Router><App /></Router>
      </I18nextProvider>
    </Provider>
    </React.StrictMode>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
